<script lang="ts">
  import TextInput from './TextInput.svelte';
  import { data } from './data';

  const fields = {
    employeeName: "Naam medewerker",
    employeeRole: "Functie medewerker",
    period: "Inzetperiode",
    customerName: "Klant/projectnaam",
    reviewerName: "Naam beoordelaar",
    reviewerRole: "Functie beoordelaar",
  };


  let errors: string[] = [];
  export function tryNext() {
    errors.length = 0;
    Object.keys(fields).forEach(key => {
      if (!$data[key]) {
        errors.push(key);
      }
    })
    return (errors.length === 0);
  }
</script>

<style>
</style>

<h3>Gegevens</h3>
{#each Object.entries(fields) as [key, label] }
  <TextInput key={key} error={errors.includes(key)} bind:value={$data[key]} label={label} />
{/each}

